import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';

/**
 * Magnet (React Bits style) — wraps a button or link; element subtly
 * follows the cursor when inside `radius`. Disabled on touch + reduced-motion.
 */
export default function Magnet({
  children,
  className = '',
  radius = 140,
  strength = 0.32,
  as: Tag = 'span',
  ...rest
}) {
  const ref = useRef(null);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const isCoarse = typeof window !== 'undefined' && window.matchMedia('(pointer: coarse)').matches;
  const reduce = typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const enabled = !isCoarse && !reduce;

  const onMove = (e) => {
    if (!enabled || !ref.current) return;
    const r = ref.current.getBoundingClientRect();
    const cx = r.left + r.width / 2;
    const cy = r.top + r.height / 2;
    const dx = e.clientX - cx;
    const dy = e.clientY - cy;
    const dist = Math.hypot(dx, dy);
    if (dist > radius) { setPos({ x: 0, y: 0 }); return; }
    setPos({ x: dx * strength, y: dy * strength });
  };
  const onLeave = () => setPos({ x: 0, y: 0 });

  const MotionTag = motion[Tag] || motion.span;
  return (
    <MotionTag
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      animate={{ x: pos.x, y: pos.y }}
      transition={{ type: 'spring', stiffness: 180, damping: 18, mass: 0.5 }}
      className={className}
      style={{ display: 'inline-block' }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}
